import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);


// Home-screen icon freshness: register the network-first service worker (production only —
// the dev/preview server stays SW-free so hot reload is unaffected). When a redeploy ships
// a new build, the next launch pulls it in automatically; no delete-and-re-add needed.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          sw?.addEventListener("statechange", () => {
            // new worker took over while we had the old one — swap to the fresh build
            if (sw.state === "activated" && navigator.serviceWorker.controller) window.location.reload();
          });
        });
      })
      .catch(() => {});
  });
}
